import { render, staticRenderFns } from "./Indicas.vue?vue&type=template&id=020ed206&"
import script from "./Indicas.vue?vue&type=script&lang=js&"
export * from "./Indicas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports